module.exports = __webpack_public_path__ + "static/media/myalgo-blue.6079b807.png";